import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { useRef, useEffect } from 'react';
import '../../../i18n/i18n.js';
import '../../../services/apiEndpoint/apiEndpoint.js';
import '../../../services/appConstants/appConstants.js';
import '../../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../../services/logout/rest-default-client/restDefaultClient.js';
import PollManager from '../../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../../services/translation/translationUtils.module.scss.js';
import '../../../services/utilities/languageUtil.js';
import '../../../services/useContactUs/ContactUs.gql.js';
import '../../../services/storageHandler/StorageHandler.js';
import '../../../services/abortablePromise/AbortablePromise.js';
import '../../../services/abortablePoller/AbortablePoller.js';
import '../../../services/abortablePoller/ResumablePoller.js';
import { queryLogs, queryFirmwareStatus, mutationFirmwareUpgrade } from './firmware.gql.js';

var logStates = [{
  logState: 'PLANNED',
  continuePoll: true,
  labelKey: 'MPLIB_FIRMWARE_UPGRADE_WAITING'
}, {
  logState: 'DOWNLOADING',
  continuePoll: true,
  labelKey: 'MPLIB_FIRMWARE_UPGRADE_UPGRADING'
}, {
  logState: 'DONE_PENDING',
  continuePoll: true,
  labelKey: 'MPLIB_FIRMWARE_UPGRADE_RESTARTING'
}, {
  logState: 'DONE',
  continuePoll: true,
  labelKey: 'MPLIB_FIRMWARE_UPGRADE_DONE'
}, {
  logState: 'FAILED',
  isError: true,
  labelKey: 'MPLIB_FIRMWARE_UPGRADE_ERROR_UNKNOWN'
}, {
  logState: 'FAILED_NO_FILE',
  isError: true,
  labelKey: 'MPLIB_FIRMWARE_UPGRADE_ERROR_UNKNOWN'
}, {
  logState: 'FAILED_UNKNOWN',
  isError: true,
  labelKey: 'MPLIB_FIRMWARE_UPGRADE_ERROR_UNKNOWN'
}, {
  logState: 'FAILED_POWER_FAILURE',
  continuePoll: true,
  isError: true,
  labelKey: 'MPLIB_FIRMWARE_UPGRADE_ERROR_POWER_FAILURE'
}, {
  logState: 'FAILED_SYSTEM_ARMED',
  continuePoll: true,
  isError: true,
  labelKey: 'MPLIB_FIRMWARE_UPGRADE_ERROR_SYSTEM_ARMED'
}, {
  logState: 'RESTARTING',
  continuePoll: true,
  labelKey: 'MPLIB_FIRMWARE_UPGRADE_RESTARTING'
} // This is not returned from the API
];

var isAllOfSameState = function isAllOfSameState(state) {
  var logs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return !logs.some(function (log) {
    return log.logState !== state;
  });
};

// Upgrade is successful when logState is DONE and the versions match
var isUpgradeSuccessful = function isUpgradeSuccessful() {
  var logs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return logs.length > 0 && logs.every(function (log) {
    return log.currentVersion === log.nextVersion && log.logState === 'DONE';
  });
};
var isUpgradeFailed = function isUpgradeFailed() {
  var logs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return logStates.some(function (state) {
    return logs.some(function (log) {
      return !!(state.isError && !state.continuePoll && log.logState === state.logState);
    });
  });
};
var isRestarting = function isRestarting() {
  var logs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return !isUpgradeSuccessful(logs) && isAllOfSameState('DONE', logs);
};
var getFailedUpgradeState = function getFailedUpgradeState() {
  var logs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var foundError = logStates.find(function (state) {
    return !!logs.find(function (log) {
      return state.isError && state.logState === log.logState;
    });
  });
  return foundError ? foundError.labelKey : '';
};
var shouldContinuePoll = function shouldContinuePoll() {
  var logs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return !!logs.length && logs.every(function (log) {
    return logStates.some(function (logState) {
      return logState.logState === log.logState && logState.continuePoll;
    });
  });
};
var containsContinueToPollFailure = function containsContinueToPollFailure() {
  var logs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return logs.some(function (log) {
    return logStates.some(function (logState) {
      return logState.logState === log.logState && logState.isError && logState.continuePoll;
    });
  });
};
var shouldStopPollAndShowError = function shouldStopPollAndShowError() {
  var logs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return logs.some(function (log) {
    return logStates.some(function (logState) {
      return logState.logState === log.logState && logState.isError && !logState.continuePoll;
    });
  });
};
var notifyContinueToPollFailure = function notifyContinueToPollFailure() {
  var newLogs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return shouldContinuePoll(newLogs) && newLogs.some(function (newLog) {
    if (containsContinueToPollFailure([newLog])) {
      return true;
    }
    // Does not contain continue to poll failure
    return false;
  });
};
var getCalculatedPercent = function getCalculatedPercent() {
  var logs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (logs.every(function (log) {
    return log.logState === 'DONE';
  })) return 100;
  var percentage = 0;
  // eslint-disable-next-line array-callback-return
  logs.map(function (log) {
    if (log.logState === 'DONE') {
      percentage += 100;
    } else {
      percentage += log.progress;
    }
  });
  return Math.floor(percentage / logs.length) || 0;
};
var getCalculatedUpgradeState = function getCalculatedUpgradeState() {
  var logs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!logs.length) {
    return '';
  }
  var allPlanned = isAllOfSameState('PLANNED', logs);
  if (allPlanned) {
    return 'MPLIB_FIRMWARE_UPGRADE_WAITING';
  }
  if (isUpgradeSuccessful(logs)) {
    return 'MPLIB_FIRMWARE_UPGRADE_DONE';
  }
  if (isRestarting(logs)) {
    return 'MPLIB_FIRMWARE_UPGRADE_RESTARTING';
  }
  return 'MPLIB_FIRMWARE_UPGRADE_UPGRADING';
};
var getFirmwareStatusAsync = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(giid, client) {
    var result, status;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return client.query({
              query: queryFirmwareStatus,
              variables: {
                giid: giid
              }
            });
          case 3:
            result = _context.sent;
            status = result.data.installation.firmware.status;
            return _context.abrupt("return", status);
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            if (_context.t0.networkError) {
              _context.next = 12;
              break;
            }
            throw _context.t0;
          case 12:
            return _context.abrupt("return", null);
          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
  return function getFirmwareStatusAsync(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var getFirmwareLogsAsync = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(giid, client) {
    var result, logSearch;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return client.query({
              query: queryLogs,
              variables: {
                giid: giid
              }
            });
          case 3:
            result = _context2.sent;
            logSearch = result.data.installation.firmware.logSearch;
            return _context2.abrupt("return", logSearch);
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            if (_context2.t0.networkError) {
              _context2.next = 12;
              break;
            }
            throw _context2.t0;
          case 12:
            return _context2.abrupt("return", null);
          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));
  return function getFirmwareLogsAsync(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var pollFirmwareUpgradeLogsAsync = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(giid, key, client, setFirmwareLogs) {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", PollManager.poll( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
              var logs, done, failed;
              return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return getFirmwareLogsAsync(giid, client);
                    case 2:
                      logs = _context3.sent;
                      setFirmwareLogs(logs);
                      done = isUpgradeSuccessful(logs);
                      failed = isUpgradeFailed(logs);
                      if (!(done || failed)) {
                        _context3.next = 10;
                        break;
                      }
                      _context3.next = 9;
                      return getFirmwareStatusAsync(giid, client);
                    case 9:
                      return _context3.abrupt("return", {
                        done: done,
                        failed: failed
                      });
                    case 10:
                      return _context3.abrupt("return", false);
                    case 11:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            })), {
              key: key,
              timeout: Infinity
            }));
          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function pollFirmwareUpgradeLogsAsync(_x5, _x6, _x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();
var startFirmwareUpgradeAsync = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(giid, client) {
    var result, FirmwareUpgrade;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return client.mutate({
              mutation: mutationFirmwareUpgrade,
              variables: {
                giid: giid
              }
            });
          case 3:
            result = _context5.sent;
            FirmwareUpgrade = result.data.FirmwareUpgrade;
            return _context5.abrupt("return", FirmwareUpgrade);
          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](0);
            if (_context5.t0.networkError) {
              _context5.next = 12;
              break;
            }
            throw _context5.t0;
          case 12:
            return _context5.abrupt("return", null);
          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 8]]);
  }));
  return function startFirmwareUpgradeAsync(_x9, _x10) {
    return _ref5.apply(this, arguments);
  };
}();
function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  });
  return ref.current;
}

export { containsContinueToPollFailure, getCalculatedPercent, getCalculatedUpgradeState, getFailedUpgradeState, getFirmwareLogsAsync, getFirmwareStatusAsync, isAllOfSameState, isRestarting, isUpgradeFailed, isUpgradeSuccessful, notifyContinueToPollFailure, pollFirmwareUpgradeLogsAsync, shouldContinuePoll, shouldStopPollAndShowError, startFirmwareUpgradeAsync, usePrevious };
